/*
 * @Author: Haotao
 * @Date: 2022-10-11 16:05:43-16 13:33:46
 * @LastEditors: Haotao
*/
import service from '@utils/request';

// 获取微信票据
const getWxTicket = data => {
  return service({
    url: '/front/selfEE/wechatSign',
    method: 'post',
    data
  })
}

// 微信支付
const getWxPay = () => {
  return service({
    url: '/front/selfEE/wechatPay',
    method: 'post',
    data: {}
  })
}

export {
  getWxTicket,
  getWxPay
}